import type { DetectionModel } from '@/types/models/DetectionModel'

export type SocketDeviceDetectionModel = {
    device_id: number
    detections: DetectionModel[]
}

export type SocketWrapperModel = {
    connected: boolean
    site_ids?: number[]
    poi_ids?: number[]
    device_ids?: number[]
    maxEventDetections?: number
}

export type SocketCheckpointDetectionModel = {
    poi_id: number
    detections: DetectionModel[]
}

export type SocketEventDetectionModel = {
    site_id: number
    detections: DetectionModel[]
}

export type SocketDetectionModel = {
    device_detections: SocketDeviceDetectionModel[]
    checkpoint_detections: SocketCheckpointDetectionModel[]
    event_detections: SocketEventDetectionModel[]
}

export const defaultSocketDetectionModel = {
    device_detections: [],
    checkpoint_detections: [],
    event_detections: []
}
